import {
  FilterMode,
  DesignShowcaseCreateMutationVariables,
  DesignShowcase_OrderBy,
  DesignShowcase,
  SortOrder,
  DesignShowcase_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const designShowcaseService = {
  createOne: buildCreateOne(
    (designShowcaseCreateVariables: DesignShowcaseCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.designShowcaseCreate(
          designShowcaseCreateVariables
        );
        return result.designShowcaseCreate;
      }
  ),

  showcaseWorkflow_Submit: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result = await api.showcaseWorkflow_Submit({
      instanceId,
      instanceVersion,
      instanceEntity,
    });
    return result.showcaseWorkflow_Submit;
  },

  showcaseWorkflow_Approve: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result = await api.showcaseWorkflow_Approve({
      instanceId,
      instanceVersion,
      instanceEntity,
    });
    return result.showcaseWorkflow_Approve;
  },

  showcaseWorkflow_Reject: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result = await api.showcaseWorkflow_Reject({
      instanceId,
      instanceVersion,
      instanceEntity,
    });
    return result.showcaseWorkflow_Reject;
  },

  showcaseWorkflow_Fail: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result = await api.showcaseWorkflow_Fail({
      instanceId,
      instanceVersion,
      instanceEntity,
    });
    return result.showcaseWorkflow_Fail;
  },

  showcaseWorkflow_Retry: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result = await api.showcaseWorkflow_Retry({
      instanceId,
      instanceVersion,
      instanceEntity,
    });
    return result.showcaseWorkflow_Retry;
  },

  showcaseWorkflow_Close: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result = await api.showcaseWorkflow_Close({
      instanceId,
      instanceVersion,
      instanceEntity,
    });
    return result.showcaseWorkflow_Close;
  },

  showcaseWorkflow_Reopen: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result = await api.showcaseWorkflow_Reopen({
      instanceId,
      instanceVersion,
      instanceEntity,
    });
    return result.showcaseWorkflow_Reopen;
  },
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.designShowcaseOne({ id });
    return result.designShowcaseOne as DesignShowcase;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: DesignShowcase_OrderBy[] | null = null,
    filter: DesignShowcase_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: DesignShowcase_Filter | undefined;
    if (searchValue !== "") {
      where = {
        OR: [
          { code: { contains: searchValue, mode: FilterMode.Insensitive } },
          { name: { contains: searchValue, mode: FilterMode.Insensitive } },
        ],
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.designShowcaseListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ code: SortOrder.Asc }, { name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.designShowcaseListWithOffset
    ) as DesignShowcase[];
    return { list, orderBy };
  },
};
